// components/ConfirmDeleteDialog.tsx
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'
import { useRef } from 'react'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void> | void
  title?: string
  body?: string
  confirmText?: string
  isLoading?: boolean
}

export function DeleteDeviceModal({
  isOpen,
  onClose,
  onConfirm,
  title = 'Delete item',
  body = 'Are you sure? This action cannot be undone.',
  confirmText = 'Delete',
  isLoading = false,
}: Props) {
  const cancelRef = useRef<HTMLButtonElement>(null)

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={isLoading ? () => {} : onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontWeight="bold">{title}</AlertDialogHeader>
          <AlertDialogBody>{body}</AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button
              ref={cancelRef}
              onClick={onClose}
              variant="outline"
              isDisabled={isLoading}
            >
              Cancel
            </Button>
            <Button colorScheme="red" onClick={onConfirm} isLoading={isLoading}>
              {confirmText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
